import React from 'react';
import { Col, Button, Form, Select, Input } from 'antd';


const ComplianceForm = ({ formname, formData, setFormData, onHndleFinish }) => {

    const handleInputChange = (e, name) => {
        const value = e.target.value; // Extract value from event object
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleSelectChange = (value, name) => {
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    return (          
        <Form
            name={formname}
            layout="inline"
            onFinish={onHndleFinish}
            className='filterTabs'
            style={{ width: '100%', paddingTop: '25px', paddingBottom: '25px', justifyContent: 'start', backgroundColor: '#FFF' }}
        >
            <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
                <Form.Item label="Lot Number" style={{ width: '100%', margin: 0 }}>
                    <Input
                        onChange={(e) => handleInputChange(e, 'lotNumber')}
                        value={formData.lotNumber}
                    />
                </Form.Item>
            </Col>
            <hr />
            <Col span={4} xs={24} sm={24} lg={24} xl={16} style={{ textAlign: 'start' }}>
                <Form.Item label="Select Region" style={{ width: '100%', marginBottom: 20 }}>
                    <Select
                        onChange={(value) => handleSelectChange(value, 'region')}
                        placeholder="Select"
                        value={formData.region}
                        options={[
                            {
                                value: 'bionet',
                                label: 'Greece',
                            },
                            {
                                value: 'univer',
                                label: 'Serbia',
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item label="Select Status" style={{ width: '100%', marginBottom: 20 }}>
                    <Select
                        onChange={(value) => handleSelectChange(value, 'status')}
                        placeholder="Select"
                        value={formData.status}
                        options={[
                            {
                                value: 'certification',
                                label: 'Certification',
                            },
                            {
                                value: 'verification',
                                label: 'Verification',
                            },
                            {
                                value: 'reception',
                                label: 'Reception',
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item label="GTIN" style={{ width: '100%', marginBottom: 20 }}>
                    <Input
                        onChange={(e) => handleInputChange(e, 'gtin')}
                        value={formData.gtin}
                    />
                </Form.Item>
                <Form.Item style={{ width: '100%', alignItems: 'start' }}>
                    <Button 
                        className="btnPrimary" 
                        disabled={(!formData.region) || (!formData.lotNumber && !formData.gtin && !formData.status)} 
                        type="primary" 
                        htmlType="submit" 
                        style={{ padding: '22px 20px', backgroundColor: (formData.region && (formData.lotNumber || formData.gtin || formData.status)) ? '#335001' : '#d9d9d9' }}>
                            Filter
                    </Button>
                </Form.Item>
            </Col>
        </Form>
    );
}

export default ComplianceForm;
